export const warehouseFeatures = [
  {
    icon: "ri-drop-line",
    title: "Waterproof Construction",
    text: "RCC flooring, raised pallets and sealed walls keep goods safe from seepage and monsoon dampness.",
  },
  {
    icon: "ri-shield-keyhole-line",
    title: "Round The Clock Security",
    text: "Gated premises with controlled entry and monitoring so your belongings are never at risk.",
  },
  {
    icon: "ri-bug-2-line",
    title: "Pest Controlled Bays",
    text: "Scheduled pest treatment and regular housekeeping across every storage bay throughout the year.",
  },
  {
    icon: "ri-fire-line",
    title: "Fire Safety Ready",
    text: "Fire extinguishers, no-smoking zones and clear access aisles maintained across the facility.",
  },
  {
    icon: "ri-scales-3-line",
    title: "Palletised Stacking",
    text: "Goods are stacked on pallets instead of the floor, protecting cartons from moisture and crushing.",
  },
  {
    icon: "ri-file-text-line",
    title: "Item-Wise Inventory",
    text: "Every intake gets a listed receipt so retrieving your goods later is quick and error free.",
  },
];

export const warehouseOptions = [
  {
    icon: "ri-home-4-line",
    title: "Household Storage",
    text: "Store an entire household or a few selected items while you shift between homes in Bangalore.",
    points: ["Safe for furniture & appliances", "Ideal for 1BHK to 4BHK volume", "Retrieve any time with notice"],
  },
  {
    icon: "ri-building-2-line",
    title: "Commercial Storage",
    text: "Archive files, retail stock, office furniture and equipment kept separately from household goods.",
    points: ["Separate commercial bays", "Department-wise labelling", "Stock in and out records"],
  },
  {
    icon: "ri-calendar-2-line",
    title: "Short & Long Term",
    text: "Whether it is a few weeks between two leases or a full year, storage is billed on actual usage.",
    points: ["Weekly or monthly plans", "Flexible retrieval", "Delivery to your destination"],
  },
];